module.exports = __webpack_public_path__ + "static/media/RMC-cta-003.d77d543c.jpg";